module.exports = __webpack_public_path__ + "media/images/dividend/ic-close-d2173045d7430a61d0a4b05d8e6d45fd.svg";